import React, { SVGProps } from 'react';

export const Session = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 21"
    width="20"
    height="21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y=".5" width="20" height="20" rx="10" fill="#0D9C56" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 11c3.314 0 6 1.007 6 2.25s-2.686 2.25-6 2.25-6-1.007-6-2.25S6.686 11 10 11Zm3.75-2a2.25 2.25 0 0 1 2.227 1.925l.014.12.002.082a.17.17 0 0 1-.233.16l-.03-.015c-.293-.19-.792-.409-1.496-.656l-.243-.084-.114-.038a.42.42 0 0 1-.265-.262l-.015-.054a1.503 1.503 0 0 0-.12-.357l-.042-.08-.083-.143-.108-.17-.1-.146a.139.139 0 0 1 .075-.218l.061-.015c.152-.032.309-.049.47-.049Zm-7.5 0c.161 0 .318.017.47.05l.06.014a.138.138 0 0 1 .093.19l-.016.028-.101.146-.108.17-.083.142-.042.081a1.509 1.509 0 0 0-.099.267l-.021.09-.015.054a.42.42 0 0 1-.213.24l-.052.022-.203.068-.302.106-.3.112a6.527 6.527 0 0 0-.982.45l-.066.042-.03.015a.17.17 0 0 1-.23-.126l-.003-.034.003-.096A2.25 2.25 0 0 1 6.25 9ZM10 8.643c.864 0 1.547.352 2.05.882l.067.073c.035.04.07.08.103.121l.043.055.06.08.08.114a.12.12 0 0 1-.092.184h-.028A16.46 16.46 0 0 0 10.185 10L10 10h-.185c-.61.007-1.2.043-1.764.109l-.334.042-.028.001a.12.12 0 0 1-.105-.154l.015-.032.077-.112.06-.08.044-.055.05-.061.053-.06.067-.073a2.742 2.742 0 0 1 1.9-.879l.15-.003Zm3.75-2.41c.497 0 .9.424.9.946s-.266 1.279-.9 1.279-.9-.757-.9-1.279c0-.522.403-.946.9-.946Zm-7.5 0c.497 0 .9.424.9.946s-.266 1.279-.9 1.279c-.635 0-.9-.757-.9-1.279 0-.522.403-.946.9-.946ZM10 5.5c.58 0 1.05.489 1.05 1.091 0 .603-.31 1.476-1.05 1.476l-.084-.004C9.236 8 8.95 7.17 8.95 6.59c0-.576.43-1.048.975-1.088L10 5.5Z"
      fill="#fff"
    />
  </svg>
);
